import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("AppErrorBoundary", error, info);
    try {
      if (sessionStorage.getItem("moo_error_reload") !== "1") {
        sessionStorage.setItem("moo_error_reload", "1");
        window.location.reload();
      }
    } catch (_e) {
      // ignore storage errors
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen bg-[#050b18] text-white flex items-center justify-center px-6">
        <div className="max-w-md w-full rounded-3xl border border-white/10 bg-white/5 p-6 text-center shadow-2xl">
          <div className="text-4xl mb-3">⚠️</div>
          <h1 className="text-lg font-semibold">Une erreur est survenue</h1>
          <p className="mt-2 text-sm text-white/70">
            Recharge la page pour repartir, ou retourne a l'accueil.
          </p>
          <div className="mt-5 flex flex-col gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-2xl bg-gradient-to-r from-amber-400 to-orange-400 px-4 py-2 text-sm font-semibold text-slate-900"
            >
              Recharger
            </button>
            <button
              type="button"
              onClick={() => (window.location.href = "/")}
              className="rounded-2xl border border-white/20 bg-white/10 px-4 py-2 text-sm font-semibold text-white/80 hover:bg-white/20"
            >
              Accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
